import { render, staticRenderFns } from "./ProviderAdd.vue?vue&type=template&id=0838a747&"
import script from "./ProviderAdd.vue?vue&type=script&lang=js&"
export * from "./ProviderAdd.vue?vue&type=script&lang=js&"
import style0 from "@/vendor/libs/vue-jstree/vue-jstree.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports